// テナントの情報を保持、必要な画面でこちらを更新する
const state = () => ({
  tenantInfo: null
})

const getters = {
  attachmentOption(state) {
    if (!state.tenantInfo) return false
    return state.tenantInfo.attachmentOption
  },
  lockGoalOption(state) {
    if (!state.tenantInfo) return false
    return state.tenantInfo.lockGoalOption
  }
}

const mutations = {
  setTenantInfo(state, tenantInfo) {
    state.tenantInfo = tenantInfo
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}